import {
    StepVariables,
    ToolContext,
} from "@services/tracking/types/trackingInfo/toolStepTrackingInfo";

type StepTypes = "start" | "submit";

const TOOL_REGISTRATION_STEPS: Record<StepTypes, StepVariables> = {
    start: {
        stepName: "Maak je profiel aan",
        stepNumber: 1,
        placement: "klantgegevens:login",
        result: {},
        option: "",
    },
    submit: {
        stepName: "registratie voltooid",
        stepNumber: 2,
        placement: "inloggen",
        result: {},
        option: "",
    },
};

const TOOL_REGISTRATION_CONTEXT: Readonly<ToolContext> = {
    name: "registration",
    type: "form",
};

export { TOOL_REGISTRATION_STEPS, TOOL_REGISTRATION_CONTEXT };
